import cx from 'classnames';
import React from 'react';

import { Tick } from '../Icon';
import * as styles from './TickList.module.css';

const TickList = ({
	children,
	list,
	direction,
}: {
	children: React.ReactNode;
	list: string[];
	direction?: 'ltr' | 'rtl';
}) => {
	return (
		<div
			className={cx(styles.bounds, {
				[styles.reverse]: direction === 'rtl',
			})}
		>
			<div className={cx(styles.content, 'beat')}>{children}</div>
			{list && list.length > 0 && (
				<ul className={styles.list}>
					{list.map((item) => (
						<li className={styles.item}>
							<div className={styles.circle}>
								<Tick className={styles.icon} />
							</div>
							{item}
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default TickList;
